<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
})
</script>

<template>
  <UTooltip text="Save">
    <UButton icon="ri:check-fill" color="green" v-bind="$attrs" trailing />
  </UTooltip>
</template>
